import React, { useState, useEffect } from 'react';
import './Work.css';
import { Link } from 'react-router-dom';
import { images } from '../../../assets';

function Work() {
  const [activeSteps, setActiveSteps] = useState([1]);

  const handleStepChange = () => {
    setActiveSteps((prevActiveSteps) => {
      if (prevActiveSteps.length === 3) {
        // If all steps are active, reset to step 1
        return [1];
      } else {
        // Otherwise, add the next step to the active steps list
        const nextStep = prevActiveSteps[prevActiveSteps.length - 1] + 1;
        return [...prevActiveSteps, nextStep];
      }
    });
  };

  useEffect(() => {
    const intervalId = setInterval(handleStepChange, 3000);
    return () => clearInterval(intervalId);
  }, [activeSteps]);


  const [activeStepMobile, setActiveStepMobile] = useState(0); // Initialize activeStep to 0 (first step)

  const handleStepChangeMobile = () => {
    setActiveStepMobile((prevActiveStep) => (prevActiveStep === 2 ? 0 : prevActiveStep + 1)); // Loop through steps 0, 1, 2
  };

  useEffect(() => {
    const intervalId = setInterval(handleStepChangeMobile, 3000);
    return () => clearInterval(intervalId);
  }, []); // Only run the effect once


  return (
    <div className='work'>
      <div className='leftside'>
        <div className='hand'>
            <img src={images.mobile} alt='mobile' />
        </div>
        <div className='leftHand'>
            <img src={images.leftHand} alt='mobile' />
        </div>
        <div className='mobileimg'>
          {/* Show the image corresponding to the active step */}
          {activeSteps.map((step, index) => (
            <img key={step} src={images[`mobile${step}`]} alt={`mobile-step-${step}`} style={{ display: index === activeSteps.length - 1 ? 'block' : 'none' }} />
          ))}
        </div>
      </div>

      <div className='rightside'>
        <div className='Steps'>

          <div className={`step1 ${activeSteps.includes(1) ? 'active' : 'inactive'}`}>
            <div className='stepLogo'>
              <img src={images.stepDownload} alt='step-download' />
            </div>
            <div className='stepInfo'>
              <div className='stepHeading'>Download Impact app</div>
              <div className='stepDetails'>
                <Link to='https://play.google.com/store/apps/details?id=com.sharesmile.share&hl=en'> <img src={images.playStore} alt="google-play" /> </Link>
                <Link to='https://apps.apple.com/in/app/impact-fitness-charity/id1143265464'> <img src={images.appleStore} alt="apple-app" /> </Link>
              </div>
            </div>
          </div>

          <div className={`step2 ${activeSteps.includes(2) ? 'active' : 'inactive'}`}>
            <div className={`stepLogo ${activeSteps.includes(2)? '' : 'enabled'}`}>
              <img src={images.donate} alt='donate' />
            </div>
            <div className='stepInfo'>
              <div className='stepTitle'>Donate steps to a cause</div>
              <div className='stepBody'>
              Choose a cause you care and start workout
              </div>
            </div>
          </div>

          <div className={`step3 ${activeSteps.includes(3) ? 'active' : 'inactive'}`}>
            <div className={`stepLogo ${activeSteps.includes(3)? '' : 'enabled'}`}>
              <img src={images.reward} alt='reward' />
            </div>
            <div className='stepInfo'>
              <div className='stepTitle'>Reach milestones & win rewards</div>
              <div className='stepBody'>
              Grab coins along your journey and unlock exclusive offers
              </div>
            </div>
          </div>
 
        </div>
      </div>

      <div className='stepsContent'>
        <div className='howImpactWork'>Here’s how Impact works</div>
        
          <div className='stepsAndInfo'>
          <div className='Steps'>

<div className={`step1 ${activeStepMobile === 0 ? 'active' : 'inactive'}`}>
  <div className={`stepLogo ${activeStepMobile === 0? '' : 'enabled'}`}>
    <img src={images.stepDownload} alt='step-download' />
  </div>        
</div>

<div className={`step2 ${activeStepMobile === 1 ? 'active' : 'inactive'}`}>
  <div className={`stepLogo ${activeStepMobile === 1? '' : 'enabled'}`}>
    <img src={images.donate} alt='donate' />
  </div>         
</div>

<div className={`step3 ${activeStepMobile === 2 ? 'active' : 'inactive'}`}>
  <div className={`stepLogo ${activeStepMobile === 2 ? '' : 'enabled'}`}>
    <img src={images.reward} alt='reward' />
  </div>
</div>
</div>


  {activeStepMobile===0&&(
    <div className='stepInfo'>
      <div className='stepHeading'>Download Impact app</div>
      <div className='stepDetails'>
        <Link to='https://play.google.com/store/apps/details?id=com.sharesmile.share&hl=en'> <img src={images.playStore} alt="google-play" /> </Link>
        <Link to='https://apps.apple.com/in/app/impact-fitness-charity/id1143265464'> <img src={images.appleStore} alt="apple-app" /> </Link>
      </div>
    </div>
  )}

  

  {activeStepMobile===1&&(
      <div className='stepInfo'>
      <div className='stepTitle'>Donate steps to a cause</div>
      <div className='stepBody'>
      Choose a cause you care and start workout
      </div>
    </div>
  )}

  

  {activeStepMobile===2&&(
    <div className='stepInfo'>
    <div className='stepTitle'>Reach milestones & win rewards</div>
    <div className='stepBody'>
    Grab coins along your journey and use them to unlock exclusive offers
    </div>
  </div>
  )}

          </div>
      </div>
    </div>
  );
}

export default Work;
